<template>
  <div class="invetory-bands">

    <div class="tabular-header inventory">
      <div>ID</div>
      <div>Quantidade</div>
      <div>PMP</div>
      <div>Status</div>
      <div>Bucket</div>
      <!-- <div>Operations</div> -->
    </div>

    <div class="inventory-ledger scrollable">

      <div v-for="band in ledgerByBand" :key="band.faixa">
        <div class="band-faixa">
          <h4>{{ band.faixa }} - {{ band.totalQty }} BTC</h4>
        </div>
        <div v-for="unit in band.units" :key="unit.unitID" class="tabular-row inventory">
          <div><span>{{ unit.unitID }}</span></div>
          <div><span>{{ unit.current.qty }} | {{ unit.origin.qty }}</span></div>
          <div><span>{{ unit.current.avgPrice.toFixed(2) }}</span></div>
          <div><span :class="['status-badge', 'status-' + unit.status]">{{ unit.status }}</span></div>
          <div><span :class="['bucket-badge', 'bucket-' + unit.bucket]">{{ unit.bucket }}</span></div>
          <!-- <div>{{ unit.unitSummary.operationsCount }}</div> -->
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import {formatDate} from '../utils/funcs.js'

export default {
  name: "inventoryLedger",
  computed: {
    ...mapState({
        marketData: state => state.marketData,
    }),
    ...mapGetters(['allUnitsByBin']),

    ledgerByBand() {
      const bins = this.allUnitsByBin;
      const binSize = this.marketData.priceBand.gridSize;

      // Retorna array ordenado por faixa
      return Object.keys(bins)
        .map(Number)
        .sort((a, b) => a - b)
        .map(bin => ({
          faixa: `${bin} - ${bin + binSize}`,
          totalQty: bins[bin].totalQty,
          units: bins[bin].units.sort((a, b) => b.current.avgPrice - a.current.avgPrice)
        }));
    },
  },
  methods: {
    formatDate
  },
};
</script>

<style>

.inventory-ledger {
  background-color: var(--table-header-bgcolor);
  color: var(--text-color);
  border-radius: 10px;
  padding: 10px;
  height: 600px;
  margin-bottom: 20px;
}

.tabular-header.inventory, .tabular-row.inventory {
  grid-template-columns: 3.3fr 1fr 1fr 1fr 1fr;
}
.band-faixa {
  background-color: #09f;
  padding: 6px 2px;
}

</style>
